import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M3.74081 1.02718L0.773911 4.08281C0.630864 4.23012 0.630864 4.4691 0.773911 4.61642L1.12 4.97285C1.2629 5.12001 1.49434 5.12016 1.63754 4.97347L3.99988 2.55177L6.36238 4.97332C6.50558 5.12016 6.73702 5.11985 6.87991 4.97269L7.22601 4.61626C7.36905 4.46895 7.36905 4.22997 7.22601 4.08265L4.25896 1.02718C4.11591 0.879858 3.88386 0.879858 3.74081 1.02718Z"
      fill="black"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const GrayUpArrow = memo(ForwardRef);
export default GrayUpArrow;
